import React, { useMemo, useRef, useState } from 'react'
import { useFieldArray } from 'react-hook-form'
import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast'
import { confirmDialog } from 'primereact/confirmdialog'
import ControllerInput from 'base/ControllerInput'
import { defaultEmptySelection } from 'helper/default'
import { errorToToast } from 'helper/error'

export default function ListaUfItem({ form, service }) {

    const { control } = form
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'lista_uf_item'
    })

    const [ufs, setUfs] = useState([])
    const toast = useRef(null)

    const loadUfs = async () => {
        try {
            const response = await service.listUfOptions()
            const options = response.data.data.map(item =>
                service.formatUfOption(item.codigo_uf, item.sigla_uf, item.descricao_uf)
            )
            options.push({ codigo_uf: null, descricao_sigla: defaultEmptySelection() })
            setUfs(options)
        } catch (err) {
            errorToToast({ err, toast })
        }
    }

    const ufSelecionadaCodigo = form.watch('uf_busca')
    const ufSelecionada = useMemo(() => {
        return ufs.find(option => option?.codigo_uf === ufSelecionadaCodigo)
    }, [ufs, ufSelecionadaCodigo])

    const adicionar = (event) => {
        event.preventDefault()

        if (!ufSelecionada || !ufSelecionada?.codigo_uf) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Selecione uma UF para adicionar.', life: 4000 })
            return
        }

        const jaExiste = fields.some(item => {
            const codigo = item?.uf?.codigo_uf || item?.cod_uf_ufli
            return codigo === ufSelecionada.codigo_uf
        })

        if (jaExiste) {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'UF já adicionada.', life: 4000 })
            return
        }

        append(service.getNewListaUfItem({
            cod_liuf_ufli: form.getValues('codigo_liuf') || null,
            cod_uf_ufli: ufSelecionada.codigo_uf,
            uf: ufSelecionada
        }))

        form.setValue('uf_busca', null, { shouldDirty: false })
    }

    const getIndexById = (row) => fields.findIndex(item => item.id === row.id)
    const descricaoUf = (row) => row?.uf?.descricao_sigla || row?.sigla_uf || ''

    return (
        <>
            <Toast ref={toast} />

            <div className="md:col-6 lg:col-4 xl:col-3 col-12 pt-0 pl-2 pb-3">
                <label className="text-sm">Adicionar UF</label>
                <div className="flex align-items-start gap-2 pt-1 w-full">
                    <ControllerInput
                        className="flex-1"
                        field="uf_busca"
                        form={form}
                        service={service}
                        type="dropdown2"
                        label=""
                        optionKey='codigo_uf'
                        optionLabel='descricao_sigla'
                        options={ufs}
                        onLoad={loadUfs}
                        placeholder="Selecione"
                        hideRefresh
                    />
                    <Button
                        icon="pi pi-plus"
                        severity="success"
                        size="small"
                        onClick={adicionar}
                    />
                </div>
            </div>

            <div className="col-12">
                <DataTable value={fields} dataKey="id" className="text-sm" size="small">
                    <Column header="UFs" body={descricaoUf} />
                    <Column
                        header=""
                        body={(row) => {
                            const index = getIndexById(row)
                            return (
                                <Button
                                    icon="pi pi-trash"
                                    text
                                    severity="danger"
                                    size="small"
                                    onClick={(event) => {
                                        event.preventDefault()
                                        const atual = fields[index]
                                        confirmDialog({
                                            message: `Confirma remover? ${descricaoUf(atual)}`,
                                            icon: 'pi pi-question-circle',
                                            accept: () => {
                                                const removeds = form.getValues('listaUfItemRemoved') || []
                                                if (atual?.codigo_ufli) {
                                                    removeds.push({ codigo_ufli: atual.codigo_ufli })
                                                    form.setValue('listaUfItemRemoved', removeds)
                                                }
                                                remove(index)
                                            }
                                        })
                                    }}
                                />
                            )
                        }}
                    />
                </DataTable>
            </div>
        </>
    )
}
